/**
 * ACCOUNT INACTIVE PAGE
 *
 * Displayed when a user's account has been deactivated.
 */

import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { UserX, Mail } from 'lucide-react';

export default function AccountInactivePage() {
  return (
    <div className='flex min-h-screen items-center justify-center p-4'>
      <Card className='max-w-md w-full'>
        <CardHeader className='text-center'>
          <div className='flex justify-center mb-4'>
            <UserX className='h-16 w-16 text-amber-500' />
          </div>
          <CardTitle className='text-2xl'>Account Inactive</CardTitle>
          <CardDescription>
            Your account has been deactivated
          </CardDescription>
        </CardHeader>
        <CardContent className='space-y-4'>
          <p className='text-sm text-muted-foreground text-center'>
            Your account is currently inactive. This may be because your account is pending approval
            or has been temporarily suspended. Please contact your administrator for more information.
          </p>
          <div className='flex flex-col gap-2'>
            <Button asChild variant='default' className='w-full'>
              <a href='mailto:support@smiledata.com'>
                <Mail className='mr-2 h-4 w-4' />
                Contact Support
              </a>
            </Button>
            <Button asChild variant='outline' className='w-full'>
              <Link to='/auth/signin'>
                Return to Sign In
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
